// extracted by mini-css-extract-plugin
export default {"with-svg-core-badge":"QOo_M","withSvgCoreBadge":"QOo_M"};